module.exports = __webpack_public_path__ + "static/app-store-badge-c9e7638a42313ce36934c9acfe730a1b.png";